import { useAppDispatch } from '../../../redux/store';
import { useState } from 'react';
import { putSupplier } from '../reducers/putSupplier';
import { Supplier } from '../type';
import { toast } from 'react-toastify';

interface updateSupplierProps {
  error: unknown;
  loading: boolean;
  editSupplier: (createClientRequest: Supplier) => Promise<void>;
}

const useUpdateSupplier = (): updateSupplierProps => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  const editSupplier = async (requestPayload: Supplier) => {
    try {
      setLoading(true);
      const resultAction = await dispatch(putSupplier(requestPayload));
      if (putSupplier.fulfilled.match(resultAction)) {
        toast.success('Supplier updated successfully');
        setLoading(false);
      }
    } catch (error) {
      setError(error);
      toast.error('Failed to update supplier');
    }finally{
      setLoading(false)
    }
  };
  return { editSupplier, loading, error };
};

export default useUpdateSupplier;
